import { z } from 'zod';
import { BOMItemType } from '../../constants/bom-item-type.js';
import { nullableUuidString, optionalUuidString, requiredUuidString, } from '../zod-helpers/index.js';
import { bomChargeCostSchema } from './bom-charge-cost-schema.js';
import { BOM_ITEM_TYPES_REQUIRING_PART } from './bom-item-types-requiring-part/index.js';
import { CHARGE_ONLY_COST_MESSAGE } from './charge-only-cost-message.js';
import { isCostOnNonChargeLine } from './is-cost-on-non-charge-line.js';
import { bomItemNameSchema, bomQuantitySchema } from './item-form.js';
import { UOM_REQUIRED_MESSAGE } from './uom-required-message.js';
export const addBomItemInputSchema = z
    .object({
    bomId: requiredUuidString('BOM is required.', 'Invalid BOM selection.'),
    partId: optionalUuidString('Invalid part selection.')
        .optional()
        .nullable()
        .transform((value) => value?.trim() || null),
    name: bomItemNameSchema,
    quantity: bomQuantitySchema,
    uomId: optionalUuidString('Invalid UOM selection.')
        .optional()
        .nullable()
        .transform((value) => value?.trim() || null)
        .optional(),
    typeId: z.enum(BOMItemType, 'Invalid BOM item type.'),
    cost: bomChargeCostSchema,
    // Outputs only: whether adding this line also sets Part.defaultBomId to this BOM; omitted defaults to true.
    linkAsDefault: z.boolean().optional().nullable(),
    // setPartDefaultBom's reassignment token: omitted refuses to move the part off an active default; null means "shown as unclaimed"; a BOM id means "shown as that BOM's current holder".
    confirmedAgainstBomId: nullableUuidString('Invalid BOM confirmation.').optional(),
})
    .superRefine((values, context) => {
    if (isCostOnNonChargeLine(values)) {
        context.addIssue({ code: 'custom', message: CHARGE_ONLY_COST_MESSAGE, path: ['cost'] });
    }
    if (!BOM_ITEM_TYPES_REQUIRING_PART.has(values.typeId))
        return;
    if (!values.partId) {
        context.addIssue({ code: 'custom', message: 'Part is required.', path: ['partId'] });
    }
    if (!values.uomId) {
        context.addIssue({ code: 'custom', message: UOM_REQUIRED_MESSAGE, path: ['uomId'] });
    }
});
//# sourceMappingURL=add-item-input.js.map